import * as event from 'api/eventAPI';

// Fonction pour récupérer les événements
export async function getEvents() {
    try {
        const response = await event.getEvents();
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des événements :', error);
        throw new Error('Erreur lors de la récupération des événements.');
    }
};

// Fonction pour créer ou mettre à jour un événement
export async function upsertEvent(data) {
    try {
        const response = await event.upsertEvent(data);
        return response;
    } catch (error) {
        console.error('Erreur lors de la création ou de la mise à jour de l\'événement :', error);
        throw new Error('Erreur lors de la création ou de la mise à jour de l\'événement.');
    }
};

// Fonction pour supprimer un événement
export async function deleteEvent(id) {
    try {
        const response = await event.deleteEvent(id);
        return response;
    } catch (error) {
        console.error('Erreur lors de la suppression de l\'événement :', error);
        throw new Error('Erreur lors de la suppression de l\'événement.');
    }
};
